<template>
    <div class="note_list_mt20">
        <div class="ListTable">
            <ListTable :headerItems="headerItems" :itemRows="drawList"/>
            <infinite-loading @infinite="infiniteHandler" force-use-infinite-wrapper=".ListTable">
                <div slot="spinner" class="mt30">{{$t('table.list.loading')}}</div>
                <div slot="no-more" class="mt30">{{$t('table.list.end_result')}}</div>
                <div slot="no-results" class="mt30">{{drawList.length === 0 ? $t('table.list.no_result') : $t('table.list.end_result')}}</div>
            </infinite-loading>
        </div>
    </div>
</template>
<script>
    import ListTable from '@/components/Table/listTable'

    export default {
        name: `NoteList`,
        components: { ListTable },
        props: [ 'notes', 'pageInfo', 'selectedCategory' ],
        data() {
            return {
                selectedIdx: '',
                headerItems: [
                    {
                        index: 0,
                        keyTitle: '★',
                        keyType: 'HeaderDefault',
                        class: [ 'idx_important' ],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    },
                    {
                        index: 1,
                        keyTitle: this.$t('table.header.title'),
                        keyType: 'HeaderDefault',
                        class: [ 'idx_title' ],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    },
                    {
                        index: 2,
                        keyTitle: this.$t('details'),
                        keyType: 'HeaderDefault',
                        class: [ 'idx_content' ],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    },
                    {
                        index: 3,
                        keyTitle: this.$t('table.header.created_on'),
                        keyType: 'HeaderDefault',
                        class: [ 'idx_date' ],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    }
                ],
                itemRows: [],
                isOrderByDesc: true,
                orderKey: `seqManagerNote`
            }
        },
        methods: {
            changeImportant( e, item, params ) {
                e.stopPropagation();
                e.preventDefault();
                this.$emit( `changeImportant`, item.values, params );
            },
            changeNoteComponent( idx ) { //Note component 변경
                this.$emit( `changeNoteComponent`, idx );
            },
            selectPresetRow( e, _seqManagerNote, i ) { //row를 클릭했을때 선택된 note를 보여준다.
                if (e.target.classList[2] === 'importantCheckBox' || e.target.parentNode.classList[2] === 'importantCheckBox') {
                    // 별 모양 바깥의 box를 클릭하면
                    return
                }
                this.$emit( `changeNoteComponent`, 2, i );
            },
            infiniteHandler( $state ) {
                this.$emit( `changeNoteListPage`, null, ( isSuccess, errCode, errLog ) => {
                    if ( isSuccess ) {
                        $state.loaded();
                    } else {
                        if ( errCode === 1 ) {
                            $state.complete();
                        } else {
                            console.error( errCode, errLog );
                            $state.error();
                        }
                    }
                } )
            },
        },
        computed: {
            drawList() {
                let itemRows = [];
                this.notes.sortByOrder( this.orderKey, this.isOrderByDesc );
                for ( let i = 0; i < this.notes.length; i ++ ) {
                    const items = [];
                    if ( this.selectedCategory === 'important' ) {
                        if ( ! this.notes[ i ].isImportant ) {
                            continue; //만약 important만 보게 sort했다면, 만약 해당 게시물이 중요게시물이 아니라면 continue
                        }
                    }
                    items.clickEvent = { func: this.selectPresetRow, params: [ this.notes[ i ].seqManagerNote, i ] }
                    items.push( {
                        index: 0,
                        keyTitle: '',
                        keyType: 'ImportantCheckBox',
                        class: ['importantCheckBox'],
                        parentClass: [''],
                        componentOptions: {},
                        keyRange: '',
                        values: this.notes[ i ].isImportant,
                        clickEvent: { func: this.changeImportant, params: [ this.notes[ i ].seqManagerNote, i ] }
                    } );
                    items.push( {
                        index: 1,
                        keyTitle: '',
                        keyType: 'Default',
                        class: [ 'text_overflow_hidden', 'display_i_b' ],
                        parentClass: [ '' ],
                        componentOptions: {},
                        keyRange: [],
                        values: this.notes[ i ].noteTitle,
                    } );
                    items.push( {
                        index: 2,
                        keyTitle: '',
                        keyType: 'Default',
                        class: [ 'text_overflow_hidden', 'display_i_b' ],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: '',
                        values: this.notes[ i ].noteContent
                    } );
                    items.push( {
                        index: 3,
                        keyTitle: '',
                        keyType: 'Default',
                        class: [],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: '',
                        values: this.moment(this.notes[ i ].createDatetime).locale(this.$t('country')).format('lll')
                    } );
                    itemRows.push( items );
                }
                return itemRows;
            }
        }
    }
</script>
<style lang="scss">
.note_list_mt20 {
  flex: 7 7 5rem;
  display: grid;
  flex-direction: column;
  overflow: hidden;
  justify-content: stretch;
  align-items: stretch;
  grid-row: 2/3;
  grid-column: 2/3;

  .ListTable {
    height: -webkit-fill-available;
    overflow: auto;
    grid-auto-rows: 50px;

    .table-header {
      .item {
        &:nth-child(1) {
          padding: 16px 0px !important;
          min-width: 122px;
        }
      }
    }

    .table-container {
      grid-template-columns: 100%;

      .item-parent {
        cursor: pointer;
        margin: 0;

        .importantCheckBox {

          img {
            padding: 20px 50px;
          }
        }

        .item {
          padding: 16px .3rem;

          &:nth-child(1) {
            flex-grow: 1;
            padding: 0;
            min-width: 122px;
          }

          &:nth-child(2) {
            flex-grow: 3;
          }

          &:nth-child(3) {
            flex-grow: 6;
          }

          &:nth-child(4) {
            flex-grow: 2;
          }
        }

        &.table-body {
          .table-col {
            padding-left: .5rem;
            padding-right: .5rem;
          }
        }

        &.table-header {
          position: sticky;
          top: 0;
          background: #f7f7f7;
          cursor: default;
        }
      }

      .table-header-container {
        .table-header {
          overflow: hidden;
        }
      }
    }
  }
}
</style>